export default function Switch(theme) {
  return {
    MuiSwitch: {
      defaultProps: {
        size: 'medium',
      },
      styleOverrides: {
        root: {
          width: 42,
          height: 26,
          padding: 0,
          '&.MuiSwitch-sizeSmall': {
            width: 40,
            height: 24,
            padding: 0,
          },
        },
        switchBase: {
          padding: 1,
          '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + .MuiSwitch-track': {
              backgroundColor: theme.palette.primary.main,
              opacity: 1,
              border: 'none',
            },
          },
        },
        thumb: {
          width: 24,
          height: 24,
          boxShadow: 'none',
        },
        track: {
          borderRadius: 13,
          border: `1px solid ${theme.palette.grey[400]}`,
          backgroundColor: theme.palette.grey[300],
          opacity: 1,
        },
      },
    },
  };
}

